try {
    /* global GIT_VERSION, GIT_COMMITHASH, GIT_BRANCH, CI_VERSION, CI_TS */
    if (GIT_VERSION || GIT_COMMITHASH || GIT_BRANCH || CI_VERSION || CI_TS) {
        window.APP_GIT_VERSION = GIT_VERSION;
        window.APP_GIT_COMMITHASH = GIT_COMMITHASH;
        window.APP_GIT_BRANCH = GIT_BRANCH;
        window.APP_CI_VERSION = CI_VERSION;
        window.APP_CI_TS = new Date(CI_TS).toLocaleString();
        console.log(
            '%c %s %c die Keure %c%s %c %s %c%s',
            'background-color:#ff004c;color:#fff;',
            window.APP_GIT_BRANCH,
            'background-color:#000;color:#fff;',
            'background-color:#000;color:#fff',
            window.APP_CI_TS,
            'background-color:#299531;color:#fff',
            window.APP_GIT_VERSION,
            'background-color:#2c9bb9;color:#fff;',
            ` ${window.APP_CI_VERSION || ''} `
        );

        const els = window.jQuery('.debug-info-version');
        els.text(
            `${window.APP_GIT_VERSION} ${window.APP_CI_VERSION
                ? `#${window.APP_CI_VERSION}`
                : ''}`
        );
    }
} catch (e) {
    console.log(e);
    console.warn('No module version found.');
}
